// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24_3x","title":"Header_title__3kA0c","side":"Header_side__16NK9"};